// The brand mark: a cairn — a deliberate stack of stones that marks a trail.
// Plain inline SVG (inherits currentColor, needs no external asset under the
// CSP). Used in the sidebar header, the login card, and empty states.

import { cn } from "@/lib/utils";

export function CairnMark({
  className,
  title,
}: {
  className?: string;
  title?: string;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={cn("size-6", className)}
      role={title ? "img" : "presentation"}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      fill="currentColor"
    >
      <ellipse cx="12" cy="20" rx="8" ry="2.6" />
      <ellipse cx="12" cy="15" rx="6.2" ry="2.3" opacity="0.86" />
      <ellipse cx="12" cy="10.6" rx="4.4" ry="2" opacity="0.72" />
      <ellipse cx="12" cy="6.8" rx="2.7" ry="1.7" opacity="0.58" />
    </svg>
  );
}
